<script setup lang="ts">

import {computed} from "vue";
import {useNumber} from "@/composables/number";

interface Props {
    modelValue: 'projects' | 'users'
    usersCount: number
    projectsCount: number
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

const { humanFormat } = useNumber()
</script>

<template>
    <v-list>
        <v-list-subheader class="text-body-1 font-weight-medium text-black mb-3">
            Filter by
        </v-list-subheader>
        <v-list-item
            density="compact"
            :slim="true"
            prepend-icon="mdi-folder-outline"
            :link="true"
            rounded="lg"
            :active="value === 'projects'"
            class="my-1"
            @click="() => value = 'projects'"
        >
            <v-list-item-title
                class="text-body-2"
                :class="value === 'projects' ? 'font-weight-bold' : null"
            >
                Projects
            </v-list-item-title>
            <template #append>
                <v-chip
                    size="small"
                    class="font-weight-bold"
                    color="grey-lighten-1"
                >
                    <span class="text-black">{{ humanFormat(props.projectsCount) }}</span>
                </v-chip>
            </template>
        </v-list-item>
        <v-list-item
            density="compact"
            :slim="true"
            prepend-icon="mdi-account-multiple-outline"
            :link="true"
            rounded="lg"
            :active="value === 'users'"
            class="my-1"
            @click="() => value = 'users'"
        >
            <v-list-item-title
                class="text-body-2"
                :class="value === 'users' ? 'font-weight-bold' : null"
            >
                Users
            </v-list-item-title>
            <template #append>
                <v-chip
                    size="small"
                    class="font-weight-bold"
                    color="grey-lighten-1"
                >
                    <span class="text-black">{{ humanFormat(props.usersCount) }}</span>
                </v-chip>
            </template>
        </v-list-item>
    </v-list>
</template>

<style scoped>
</style>
